<script setup lang="ts"></script>

<template>
    <div
        class="contents [&>*]:border-row-separator text-xs [&>*]:border-b [&>*]:border-t [&>*]:bg-row-heading-background">
        <slot></slot>
    </div>
</template>

<style scoped></style>
